<template>
  <mdb-container>
    <mdb-row>
      <mdb-col>
        <Errors v-show="!!error" :error="error" />
        <div v-show="showSpinner">
          <Spinner />
        </div>
      </mdb-col>
    </mdb-row>

    <mdb-row>
      <mdb-tbl striped borderless class="wide">
        <mdb-tbl-head>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Created On </th>
            <th>Action</th>
          </tr>
        </mdb-tbl-head>

        <transition-group tag="tbody" name="fade">
          <tr v-for="assetState in assetStateList.rows" :key="assetState.id">
            <td>{{ assetState.name }}</td>
            <td>{{ assetState.description }}</td>
            <td>{{ assetState.created_at | formatDate }}</td>
            <td>
              <mdb-btn
                color="dark"
                v-on:click="removeAssetState(assetState)"
                outline="primary"
                icon="minus"
                size="sm"
                >Remove</mdb-btn
              >
            </td>
          </tr>
        </transition-group>
      </mdb-tbl>
    </mdb-row>

    <mdb-row>
      <mdb-modal :show="showDeleteModal" @close="showDeleteModal = false">
        <mdb-modal-header>
          <mdb-modal-title
            >Remove Asset State ({{ selectedAssetState.name }})
          </mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body
          >Do you want to permanently delete this asset state?

          <strong>{{ selectedAssetState.name }}</strong>
          <br />
          <strong
            >Asset Description: {{ selectedAssetState.description }}
          </strong> <br/><br/>
          <i> Note: This asset state will no longer be recognized by scanning systems.</i>
        </mdb-modal-body>
        <mdb-modal-footer>
          <mdb-btn outline="primary" @click.native="showDeleteModal = false"
            >No</mdb-btn
          >
          <mdb-btn color="primary" v-on:click="deleteAssetState()"
            >Yes, Delete</mdb-btn
          >
        </mdb-modal-footer>
      </mdb-modal>
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import dateFns from "date-fns";
import Errors from "@/components/Errors";
import Spinner from "@/components/Spinner";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbTbl,
  mdbTblHead,
  mdbModal,
  mdbModalTitle,
  mdbModalHeader,
  mdbModalFooter,
  mdbModalBody,
} from "mdbvue";
// import Spinner from "@/components/Spinner";

export default {
  name: "assetStateList",
  props: {
    assetStates: {
      type: Array,
      required: true,
    },
  },

  filters: {
    formatDate(date) {
      return dateFns.format(date, "MMMM Do [at] h:mm:ss a");
    },
  },

  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbTbl,
    mdbTblHead,
    mdbModal,
    mdbModalTitle,
    mdbModalHeader,
    mdbModalFooter,
    mdbModalBody,
    Spinner,
    Errors,
  },
  data() {
    return {
      isLoading: true,
      showDeleteModal: false,
      selectedAssetState: {},
      error: "",
      assetStateList: {
        rows: [],
      },
    };
  },
  created() {
    this.assetStateList.rows = this.assetStates;
    this.isLoading = false;
  },
  methods: {
    removeAssetState(assetState) {
      this.selectedAssetState = assetState;
      this.showDeleteModal = true;
    },

    deleteAssetState() {
      this.isLoading = true;
      this.showDeleteModal = false;
      api
        .deleteAssetState(this.selectedAssetState.id)
        .then((response) => {
          this.assetStateList.rows = [...response.data];
          this.isLoading = false;
        })
        .catch((error) => {
          this.error = error.response.data.errors.full_messages[0];
        });
    },
  },
  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
};
</script>

<style scoped lang="scss">
.wide {
  width: 80vw;
}
</style>
